import { FileDBValue, getResizedStoragePath, UnuploadedFileDBValue } from '@hb/shared'
import { useEffect, useMemo, useState } from 'react'

export const useFilePath = (value?: FileDBValue | UnuploadedFileDBValue | null) => {
  const [recentlyUploaded, setRecentlyUploaded] = useState<boolean>(() => {
    if (!value?.uploadedOn) return false
    const modifiedOn = Math.max(value.uploadedOn, value.movedOn ?? 0)
    const timeSinceUpload = Date.now() - modifiedOn
    return timeSinceUpload <= 5000
  })

  useEffect(() => {
    if (!value?.uploadedOn) {
      setRecentlyUploaded(false)
      return
    }

    const modifiedOn = Math.max(value.uploadedOn, value.movedOn ?? 0)
    const timeSinceUpload = Date.now() - modifiedOn

    if (timeSinceUpload > 5000) {
      setRecentlyUploaded(false)
      return
    }

    setRecentlyUploaded(true)
    const timeout = setTimeout(() => {
      setRecentlyUploaded(false)
    }, 5000 - timeSinceUpload)
    return () => clearTimeout(timeout)
  }, [value])
  const downloadPath = useMemo(
    () => (value?.storagePath ? getResizedStoragePath(value.storagePath, value.type) : null),
    [value],
  )

  return {
    downloadPath: value?.uploadedOn && !recentlyUploaded ? downloadPath : undefined,
    recentlyUploaded,
  }
}
